import React from 'react'
import AdvancedSearch from '../advanced-search'

const AdvancedSearchDa = () => {
    return <AdvancedSearch languageCode="da" />
}

export default AdvancedSearchDa
